const initialState = {
  status: "invalid",
};

export default (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case "ARTICLES_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "ARTICLES_SUCCESS":
      return {
        ...state,
        status: "success",
        data: payload.data,
        meta: payload.meta,
      };
    case "ARTICLES_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
